import { render } from "./TabulatorLegalEntity.vue?vue&type=template&id=50a194a8"
import script from "./TabulatorLegalEntity.vue?vue&type=script&lang=js"
export * from "./TabulatorLegalEntity.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__